<template>
  <div>
    <v-dialog v-model="dialog" width="900" scrollable persistent>
      <v-card>

        <!-- Cabecera -->
        <v-card-title class="blue darken-4 white--text py-2 px-4">
          <v-icon left color="white">mdi-tag-plus-outline</v-icon>
          Registro de Promoción
          <v-spacer />
          <v-btn icon dark small @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-stepper v-model="step" class="elevation-0">

            <v-stepper-header class="elevation-0" style="border-bottom:1px solid #e0e0e0;">
              <v-stepper-step :complete="step > 1" step="1" :color="step > 1 ? (step1Complete ? 'blue darken-4' : 'red darken-1') : 'blue darken-4'" style="cursor:pointer;" @click="step = 1">Clasificación</v-stepper-step>
              <v-divider />
              <v-stepper-step :complete="step > 2" step="2" :color="step > 2 ? (step2Complete ? 'blue darken-4' : 'red darken-1') : 'blue darken-4'" style="cursor:pointer;" @click="step = 2">Financiero</v-stepper-step>
              <v-divider />
              <v-stepper-step :complete="step > 3" step="3" :color="step > 3 ? (step3Complete ? 'blue darken-4' : 'red darken-1') : 'blue darken-4'" style="cursor:pointer;" @click="step = 3">Detalles</v-stepper-step>
              <v-divider />
              <v-stepper-step :complete="step > 4" step="4" :color="step > 4 ? (step4Complete ? 'blue darken-4' : 'red darken-1') : 'blue darken-4'" style="cursor:pointer;" @click="step = 4">Vigencia</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>

              <!-- ─── Step 1: Clasificación ─── -->
              <v-stepper-content step="1" class="pa-4">

                <!-- Usar Template -->
                <v-sheet color="blue lighten-5" rounded class="pa-3 mb-4 d-flex align-center" style="gap:12px;">
                  <v-icon color="blue darken-2">mdi-lightning-bolt</v-icon>
                  <div class="flex-grow-1">
                    <div class="body-2 font-weight-bold blue--text text--darken-3">Usar Template</div>
                    <div class="caption grey--text">Precarga campos desde una plantilla existente</div>
                  </div>
                  <v-switch v-model="useTemplate" inset hide-details dense color="blue darken-2" />
                </v-sheet>

                <!-- Sección 01 -->
                <div class="section-box pa-4">
                  <div class="section-num-row mb-4">
                    <span class="section-num">01</span>
                    <span class="section-title">Clasificación</span>
                  </div>

                  <p class="field-label mb-2">UNIDAD DE NEGOCIO <span class="red--text">*</span></p>
                  <div v-if="loadingUnidades" class="mb-3">
                    <v-progress-linear indeterminate color="blue darken-4" />
                  </div>
                  <div class="d-flex flex-wrap mb-4" style="gap:8px;" v-else>
                    <v-chip
                      v-for="u in unidades" :key="u.id"
                      :color="selectedUnidades.includes(u.id) ? 'blue darken-4' : ''"
                      :dark="selectedUnidades.includes(u.id)"
                      outlined
                      @click="toggleUnidad(u.id)"
                      class="font-weight-medium"
                    >{{ u.nombre }}</v-chip>
                  </div>

                  <p class="field-label mb-2 mt-3">CATEGORÍA <span class="red--text">*</span></p>
                  <div v-if="loadingCategorias">
                    <v-progress-linear indeterminate color="blue darken-4" class="mb-3" />
                  </div>
                  <div v-else-if="selectedUnidades.length === 0" class="text-center grey--text py-3">
                    <v-icon color="grey lighten-1">mdi-information-outline</v-icon>
                    <div class="caption mt-1">Selecciona una unidad de negocio para ver sus categorías.</div>
                  </div>
                  <div v-else-if="categoriaOptions.length === 0" class="text-center grey--text py-3">
                    <div class="caption">Sin categorías disponibles.</div>
                  </div>
                  <div v-else class="sel-grid mb-4">
                    <div
                      v-for="c in categoriaOptions" :key="c.id"
                      class="sel-card" :class="{ 'sel-card--active': form.categoria === c.id }"
                      @click="form.categoria = c.id"
                    >
                      <div class="sel-icon">📋</div>
                      <div class="caption">{{ c.nombre }}</div>
                    </div>
                  </div>

                  <p class="field-label mb-2">ÁREA <span class="red--text">*</span></p>
                  <div v-if="loadingAreas">
                    <v-progress-linear indeterminate color="blue darken-4" class="mb-3" />
                  </div>
                  <div v-else-if="selectedUnidades.length === 0" class="text-center grey--text py-3">
                    <v-icon color="grey lighten-1">mdi-information-outline</v-icon>
                    <div class="caption mt-1">Selecciona una unidad de negocio para ver sus áreas.</div>
                  </div>
                  <div v-else-if="areaOptions.length === 0" class="text-center grey--text py-3">
                    <div class="caption">Sin áreas disponibles.</div>
                  </div>
                  <div v-else class="sel-grid">
                    <div
                      v-for="a in areaOptions" :key="a.id"
                      class="sel-card" :class="{ 'sel-card--active': form.area === a.id }"
                      @click="form.area = a.id"
                    >
                      <div class="sel-icon">🏛️</div>
                      <div class="caption">{{ a.nombre }}</div>
                    </div>
                  </div>
                </div>

              </v-stepper-content>

              <!-- ─── Step 2: Financiero ─── -->
              <v-stepper-content step="2" class="pa-4">

                <div class="section-box pa-4">
                  <div class="section-num-row mb-4">
                    <span class="section-num">02</span>
                    <span class="section-title">Configuración Financiera</span>
                  </div>

                  <p class="field-label mb-2">TIPO DE PAGO <span class="red--text">*</span></p>
                  <div class="sel-grid mb-4" style="grid-template-columns: repeat(3,1fr);">
                    <div
                      v-for="t in optsTiposPago" :key="t.id"
                      class="sel-card" :class="{ 'sel-card--active': form.tipoPago === t.id }"
                      @click="form.tipoPago = t.id"
                    >
                      <div class="sel-icon">{{ t.emoji }}</div>
                      <div class="caption font-weight-medium">{{ t.label }}</div>
                    </div>
                  </div>

                  <p class="field-label mb-2">PLAN DE PAGO <span class="red--text">*</span></p>
                  <div class="sel-grid" style="grid-template-columns: repeat(2,1fr);">
                    <div
                      v-for="p in optsPlanes" :key="p.id"
                      class="sel-card" :class="{ 'sel-card--active': form.planPago === p.id }"
                      @click="form.planPago = p.id"
                    >
                      <div class="sel-icon">{{ p.emoji }}</div>
                      <div class="caption font-weight-medium">{{ p.label }}</div>
                    </div>
                  </div>
                </div>

              </v-stepper-content>

              <!-- ─── Step 3: Detalles ─── -->
              <v-stepper-content step="3" class="pa-4">

                <div class="section-box pa-4">
                  <div class="section-num-row mb-4">
                    <span class="section-num">03</span>
                    <span class="section-title">Detalles de la Promoción</span>
                  </div>

                  <p class="field-label mb-1">NOMBRE <span class="red--text">*</span></p>
                  <v-text-field v-model.trim="form.nombre" dense outlined />

                  <p class="field-label mb-1">DESCRIPCIÓN</p>
                  <v-textarea v-model.trim="form.descripcion" dense outlined rows="3" />

                  <p class="field-label mb-2">ESTADO <span class="red--text">*</span></p>
                  <div class="d-flex flex-wrap mb-4" style="gap:8px;">
                    <v-chip
                      v-for="e in optsEstados" :key="e"
                      :color="form.estado === e ? 'blue darken-3' : ''"
                      :dark="form.estado === e"
                      outlined
                      @click="form.estado = e"
                    >{{ e }}</v-chip>
                  </div>

                  <p class="field-label mb-2">MODALIDAD <span class="red--text">*</span></p>
                  <div class="sel-grid mb-4" style="grid-template-columns: repeat(3,1fr);">
                    <div
                      v-for="m in optsModalidades" :key="m.id"
                      class="sel-card" :class="{ 'sel-card--active': form.modalidad === m.id }"
                      @click="form.modalidad = m.id"
                    >
                      <div class="sel-icon">{{ m.emoji }}</div>
                      <div class="caption font-weight-medium">{{ m.label }}</div>
                      <div class="caption grey--text" style="font-size:10px;">{{ m.desc }}</div>
                    </div>
                  </div>

                  <v-divider class="mb-3" />

                  <div class="d-flex align-center justify-space-between mb-2">
                    <p class="field-label mb-0">CONCEPTOS DE DESCUENTO <span class="red--text">*</span></p>
                    <v-btn small color="blue darken-4" dark tile @click="openConceptosModal">
                      <v-icon left small>mdi-plus</v-icon> Agregar
                    </v-btn>
                  </div>
                  <v-data-table
                    :headers="headersConceptos"
                    :items="conceptossels"
                    :items-per-page="-1"
                    disable-pagination
                    hide-default-footer
                    class="elevation-1"
                  >
                    <template v-slot:[`item.descuento`]="{ item }">
                      <v-text-field
                        v-model.number="item.descuento"
                        class="end-input"
                        dense outlined hide-details type="number"
                        :suffix="item.porcentual ? '%' : 'Bs.'"
                        style="max-width:130px;"
                      />
                    </template>
                    <template v-slot:[`item.porcentual`]="{ item }">
                      <v-checkbox
                        v-model="item.porcentual"
                        :label="item.porcentual ? 'Porcentual' : 'Monto'"
                        @change="onChangeTipo(item)"
                        color="green" hide-details dense
                      />
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon class="red--text" @click="eliminarConcepto(item)">mdi-delete</v-icon>
                    </template>
                  </v-data-table>
                  <div v-if="conceptossels.length === 0" class="text-center grey--text py-4">
                    <v-icon color="grey lighten-1">mdi-tag-off-outline</v-icon>
                    <div class="caption mt-1">Sin conceptos agregados.</div>
                  </div>
                </div>

              </v-stepper-content>

              <!-- ─── Step 4: Vigencia (Calendario) ─── -->
              <v-stepper-content step="4" class="pa-4">

                <div class="section-box pa-4">
                  <div class="section-num-row mb-4">
                    <span class="section-num">04</span>
                    <span class="section-title">Días de Vigencia</span>
                  </div>

                  <!-- Navegación del mes -->
                  <div class="cal-nav">
                    <v-btn icon small @click="prevMonth"><v-icon>mdi-chevron-left</v-icon></v-btn>
                    <span class="body-1 font-weight-medium">{{ calendarMonthLabel }}</span>
                    <v-btn icon small @click="nextMonth"><v-icon>mdi-chevron-right</v-icon></v-btn>
                  </div>

                  <!-- Hint -->
                  <div class="d-flex align-start mb-3" style="gap:6px;">
                    <v-icon small color="amber darken-2" class="mt-0">mdi-lightbulb-outline</v-icon>
                    <span class="caption grey--text">Haz clic para seleccionar un día. Arrastra para seleccionar un rango. Puedes combinar días individuales y múltiples rangos libremente.</span>
                  </div>

                  <!-- Grilla de días -->
                  <div class="cal-grid" @mouseleave="onCalMouseLeave">
                    <div v-for="h in calHeaders" :key="h" class="cal-header">{{ h }}</div>
                    <div
                      v-for="(day, i) in calendarDays" :key="i"
                      class="cal-day"
                      :class="{
                        'cal-day--empty': !day,
                        'cal-day--selected': day && isDaySelected(day),
                        'cal-day--drag': day && isDayInDrag(day),
                      }"
                      @mousedown.prevent="day && onDayMousedown(day)"
                      @mouseover="day && onDayMouseover(day)"
                      @mouseup="day && onDayMouseup(day)"
                    >
                      <span v-if="day">{{ day }}</span>
                    </div>
                  </div>

                  <!-- Acciones del calendario -->
                  <div class="d-flex align-center mt-3" style="gap:8px;">
                    <v-btn small outlined color="blue darken-4" @click="selectAllMonth">Seleccionar todo el mes</v-btn>
                    <v-btn small outlined color="grey" @click="clearDays">Limpiar</v-btn>
                  </div>

                  <!-- Contador -->
                  <div class="cal-count mt-3">
                    <span class="cal-count-num">{{ selectedDays.length }}</span>
                    <span class="caption ml-2 grey--text">
                      {{ selectedDays.length === 0 ? 'Ningún día seleccionado' : selectedDays.length === 1 ? 'día seleccionado' : 'días seleccionados' }}
                    </span>
                  </div>

                  <!-- Leyenda -->
                  <div class="d-flex align-center mt-2" style="gap:16px;">
                    <div class="d-flex align-center" style="gap:6px;">
                      <div class="cal-legend cal-legend--selected"></div>
                      <span class="caption">Seleccionado</span>
                    </div>
                    <div class="d-flex align-center" style="gap:6px;">
                      <div class="cal-legend cal-legend--drag"></div>
                      <span class="caption">Arrastrando</span>
                    </div>
                  </div>
                </div>

                <!-- Resumen antes de guardar -->
                <div class="mt-4">
                  <!-- Banner título -->
                  <div class="rsm-header">
                    <v-icon color="white" class="mr-2">mdi-clipboard-check-outline</v-icon>
                    <span>Resumen de la Promoción</span>
                    <v-spacer />
                    <v-chip x-small :color="form.estado === 'Activo' ? 'green lighten-1' : 'grey lighten-1'" dark>
                      {{ form.estado || 'Sin estado' }}
                    </v-chip>
                  </div>

                  <!-- Nombre destacado -->
                  <div class="rsm-nombre">
                    <div class="rsm-nombre-text">{{ form.nombre || 'Sin nombre' }}</div>
                    <div class="rsm-nombre-desc">{{ form.descripcion || 'Sin descripción' }}</div>
                  </div>

                  <!-- Bloques de info -->
                  <v-row dense class="mt-0">

                    <!-- Clasificación -->
                    <v-col cols="12" sm="6">
                      <div class="rsm-block">
                        <div class="rsm-block-title">
                          <v-icon x-small color="blue darken-4" class="mr-1">mdi-tag-outline</v-icon>
                          Clasificación
                        </div>
                        <div class="rsm-row">
                          <span class="rsm-key">Unidad(es)</span>
                          <span class="rsm-val">
                            <v-chip v-for="uid in selectedUnidades" :key="uid" x-small color="blue darken-4" dark class="mr-1">
                              {{ (unidades.find(u => u.id === uid) || {}).nombre || uid }}
                            </v-chip>
                            <span v-if="!selectedUnidades.length" class="grey--text">—</span>
                          </span>
                        </div>
                        <div class="rsm-row">
                          <span class="rsm-key">Categoría</span>
                          <span class="rsm-val">{{ (categoriaOptions.find(c => c.id === form.categoria) || {}).nombre || '—' }}</span>
                        </div>
                        <div class="rsm-row">
                          <span class="rsm-key">Área</span>
                          <span class="rsm-val">{{ (areaOptions.find(a => a.id === form.area) || {}).nombre || '—' }}</span>
                        </div>
                      </div>
                    </v-col>

                    <!-- Financiero -->
                    <v-col cols="12" sm="6">
                      <div class="rsm-block">
                        <div class="rsm-block-title">
                          <v-icon x-small color="blue darken-4" class="mr-1">mdi-cash-multiple</v-icon>
                          Financiero
                        </div>
                        <div class="rsm-row">
                          <span class="rsm-key">Tipo de pago</span>
                          <span class="rsm-val">{{ form.tipoPago || '—' }}</span>
                        </div>
                        <div class="rsm-row">
                          <span class="rsm-key">Plan de pago</span>
                          <span class="rsm-val">{{ form.planPago || '—' }}</span>
                        </div>
                        <div class="rsm-row">
                          <span class="rsm-key">Modalidad</span>
                          <span class="rsm-val">{{ form.modalidad || '—' }}</span>
                        </div>
                      </div>
                    </v-col>

                    <!-- Conceptos -->
                    <v-col cols="12" sm="6">
                      <div class="rsm-block">
                        <div class="rsm-block-title">
                          <v-icon x-small color="blue darken-4" class="mr-1">mdi-tag-multiple-outline</v-icon>
                          Conceptos de Descuento
                        </div>
                        <div v-if="!conceptossels.length" class="rsm-empty">Sin conceptos</div>
                        <div v-for="c in conceptossels" :key="c.id" class="rsm-row">
                          <span class="rsm-key">{{ c.nombre }}</span>
                          <span class="rsm-val rsm-descuento">
                            {{ c.descuento }}{{ c.porcentual ? '%' : ' Bs.' }}
                          </span>
                        </div>
                      </div>
                    </v-col>

                    <!-- Vigencia -->
                    <v-col cols="12" sm="6">
                      <div class="rsm-block">
                        <div class="rsm-block-title">
                          <v-icon x-small color="blue darken-4" class="mr-1">mdi-calendar-range</v-icon>
                          Vigencia
                        </div>
                        <div class="rsm-row">
                          <span class="rsm-key">Mes</span>
                          <span class="rsm-val">{{ calendarMonthLabel }}</span>
                        </div>
                        <div class="rsm-row">
                          <span class="rsm-key">Días seleccionados</span>
                          <span class="rsm-val">
                            <v-chip x-small :color="selectedDays.length > 0 ? 'blue darken-4' : 'grey'" dark>
                              {{ selectedDays.length }} día(s)
                            </v-chip>
                          </span>
                        </div>
                        <div class="rsm-row" style="flex-wrap:wrap; gap:4px;">
                          <span class="rsm-key" style="width:100%;">Fechas</span>
                          <span v-if="!vigenciaGrupos.length" class="grey--text caption">—</span>
                          <v-chip
                            v-for="(g, i) in vigenciaGrupos" :key="i"
                            x-small
                            :color="g.range ? 'blue darken-4' : 'blue lighten-4'"
                            :dark="g.range"
                            class="mb-1"
                          >
                            <v-icon x-small left>{{ g.range ? 'mdi-calendar-range' : 'mdi-calendar' }}</v-icon>
                            {{ g.label }}
                          </v-chip>
                        </div>
                      </div>
                    </v-col>

                  </v-row>
                </div>

              </v-stepper-content>

            </v-stepper-items>
          </v-stepper>
        </v-card-text>

        <v-divider />
        <p v-if="errorMsg" class="text-center red--text mb-0 mt-2 mx-4 body-2">{{ errorMsg }}</p>
        <v-progress-linear v-if="loading" indeterminate color="blue darken-4" />

        <v-card-actions class="px-4 py-3">
          <v-btn v-if="step > 1" outlined rounded @click="step--">
            <v-icon left>mdi-arrow-left</v-icon> Volver
          </v-btn>
          <v-spacer />
          <v-btn outlined rounded @click="dialog = false">
            <v-icon left>mdi-close</v-icon> Cancelar
          </v-btn>
          <v-btn v-if="step < 4" color="primary" rounded @click="goNext">
            Continuar <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
          <v-btn v-if="step === 4" color="green" dark rounded :disabled="loading" @click="guardar">
            <v-icon left>mdi-content-save</v-icon> Guardar Promoción
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- Sub-modals -->
    <Conceptos ref="xconceptosmodal" v-on:conceptos_sel="onConceptosSel" />
  </div>
</template>

<script>
import gql from 'graphql-tag';
import xaxios from '@/xaxios';
import Conceptos from '@/views/promociones/listar-conceptos.vue';

export default {
  name: 'PromoCreateV2',
  components: { Conceptos },

  data() {
    return {
      dialog: false,
      step: 1,
      loading: false,
      loadingUnidades: false,
      errorMsg: '',
      useTemplate: false,

      // Unidades
      unidades: [],
      selectedUnidades: [],
      areaOptions: [],
      loadingAreas: false,
      categoriaOptions: [],
      loadingCategorias: false,

      // Conceptos
      conceptossels: [],

      // Calendario
      calendarYear: new Date().getFullYear(),
      calendarMonth: new Date().getMonth(),
      selectedDays: [],
      isDragging: false,
      dragStartDay: null,
      dragEndDay: null,

      // Form
      form: {
        categoria: null,
        tipoPago: null,
        planPago: null,
        modalidad: null,
        nombre: '',
        descripcion: '',
        estado: null,
      },

      headersConceptos: [
        { text: '#', value: 'nro', width: 40 },
        { text: 'Concepto', value: 'nombre' },
        { text: 'Tipo descuento', value: 'porcentual', width: 150 },
        { text: 'Descuento', value: 'descuento', width: 160 },
        { text: '', value: 'actions', width: 50 },
      ],

      calHeaders: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'],

      optsTiposPago: [
        { id: 'promocional', label: 'Promocional', emoji: '🎯' },
        { id: 'ancla',       label: 'Ancla',       emoji: '⚓' },
        { id: 'normal',      label: 'Normal',      emoji: '📋' },
      ],

      optsPlanes: [
        { id: 'credito', label: 'Crédito', emoji: '💳' },
        { id: 'contado', label: 'Contado', emoji: '💵' },
      ],

      optsEstados: ['Activo', 'Inactivo', 'Borrador', 'Archivado', 'Pendiente'],

      optsModalidades: [
        { id: 'teorico',          label: 'Teórico',          emoji: '📖', desc: 'Solo contenido teórico' },
        { id: 'practico',         label: 'Práctico',         emoji: '🔬', desc: 'Enfoque en práctica' },
        { id: 'teorico_practico', label: 'Teórico / Práctico', emoji: '⚖️', desc: 'Combinación de ambos' },
      ],
    };
  },

  computed: {
    step1Complete() {
      return this.selectedUnidades.length > 0 && !!this.form.categoria && !!this.form.area;
    },
    step2Complete() {
      return !!this.form.tipoPago && !!this.form.planPago;
    },
    step3Complete() {
      return !!this.form.nombre && !!this.form.estado && !!this.form.modalidad && this.conceptossels.length > 0;
    },
    step4Complete() {
      return this.selectedDays.length > 0;
    },
    stepColor() {
      return (n) => {
        if (this.step === n) return 'blue darken-4';
        const done = [this.step1Complete, this.step2Complete, this.step3Complete, this.step4Complete][n - 1];
        return done ? 'blue darken-4' : 'red darken-1';
      };
    },
    sortedSelectedDays() {
      return [...this.selectedDays].sort();
    },
    vigenciaGrupos() {
      const days = this.sortedSelectedDays;
      if (!days.length) return [];
      const groups = [];
      let start = days[0];
      let prev = days[0];
      for (let i = 1; i < days.length; i++) {
        const diffDays = (new Date(days[i]) - new Date(prev)) / 86400000;
        if (diffDays === 1) {
          prev = days[i];
        } else {
          groups.push({ label: start === prev ? start : `${start} al ${prev}`, range: start !== prev });
          start = days[i];
          prev = days[i];
        }
      }
      groups.push({ label: start === prev ? start : `${start} al ${prev}`, range: start !== prev });
      return groups;
    },
    calendarMonthLabel() {
      const meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      return `${meses[this.calendarMonth]} ${this.calendarYear}`;
    },
    daysInMonth() {
      return new Date(this.calendarYear, this.calendarMonth + 1, 0).getDate();
    },
    firstWeekday() {
      const d = new Date(this.calendarYear, this.calendarMonth, 1).getDay();
      return d === 0 ? 6 : d - 1;
    },
    calendarDays() {
      const days = [];
      for (let i = 0; i < this.firstWeekday; i++) days.push(null);
      for (let d = 1; d <= this.daysInMonth; d++) days.push(d);
      return days;
    },
    dragRange() {
      if (!this.isDragging || !this.dragStartDay || !this.dragEndDay) return [];
      const s = Math.min(this.dragStartDay, this.dragEndDay);
      const e = Math.max(this.dragStartDay, this.dragEndDay);
      const r = [];
      for (let d = s; d <= e; d++) r.push(d);
      return r;
    },
  },

  methods: {
    openmodal() {
      this.dialog = true;
      this.step = 1;
      this.errorMsg = '';
      this.loading = false;
      this.useTemplate = false;
      this.selectedUnidades = [];
      this.areaOptions = [];
      this.conceptossels = [];
      this.selectedDays = [];
      this.isDragging = false;
      this.dragStartDay = null;
      this.dragEndDay = null;
      this.calendarYear = new Date().getFullYear();
      this.calendarMonth = new Date().getMonth();
      this.form = { area: null, categoria: null, tipoPago: null, planPago: null, modalidad: null, nombre: '', descripcion: '', estado: null };
      this.loadUnidades();
    },

    async loadUnidades() {
      this.loadingUnidades = true;
      try {
        const result = await this.$apollo.query({
          query: gql`query { NegociosAll { id nombre } }`,
        });
        this.unidades = result.data.NegociosAll;
      } catch (e) {
        window.console.error(e);
      } finally {
        this.loadingUnidades = false;
      }
    },

    toggleUnidad(id) {
      const idx = this.selectedUnidades.indexOf(id);
      if (idx >= 0) this.selectedUnidades.splice(idx, 1);
      else this.selectedUnidades.push(id);
      this.form.area = null;
      this.form.categoria = null;
      this.loadAreas();
      this.loadCategorias();
    },

    async loadAreas() {
      if (this.selectedUnidades.length === 0) { this.areaOptions = []; return; }
      this.loadingAreas = true;
      try {
        const promises = this.selectedUnidades.map(uid =>
          this.$apollo.query({
            query: gql`query($id: Int!) { getAreas(unidad_negocio_id: $id) { id nombre } }`,
            variables: { id: uid },
            fetchPolicy: 'network-only',
          })
        );
        const results = await Promise.all(promises);
        const seen = new Set();
        const areas = [];
        results.forEach(r => {
          (r.data.getAreas || []).forEach(a => {
            if (!seen.has(a.id)) { seen.add(a.id); areas.push(a); }
          });
        });
        this.areaOptions = areas;
      } catch (e) {
        window.console.error(e);
      } finally {
        this.loadingAreas = false;
      }
    },

    async loadCategorias() {
      if (this.selectedUnidades.length === 0) { this.categoriaOptions = []; return; }
      this.loadingCategorias = true;
      try {
        const promises = this.selectedUnidades.map(uid =>
          this.$apollo.query({
            query: gql`query($id: Int!) { getCategorias(unidad_negocio_id: $id) { id nombre } }`,
            variables: { id: uid },
            fetchPolicy: 'network-only',
          })
        );
        const results = await Promise.all(promises);
        const seen = new Set();
        const cats = [];
        results.forEach(r => {
          (r.data.getCategorias || []).forEach(c => {
            if (!seen.has(c.id)) { seen.add(c.id); cats.push(c); }
          });
        });
        this.categoriaOptions = cats;
      } catch (e) {
        window.console.error(e);
      } finally {
        this.loadingCategorias = false;
      }
    },

    // ── Calendario ────────────────────────────
    dayKey(day) {
      return `${this.calendarYear}-${String(this.calendarMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    },
    isDaySelected(day) {
      return this.selectedDays.includes(this.dayKey(day));
    },
    isDayInDrag(day) {
      return this.dragRange.includes(day);
    },
    prevMonth() {
      if (this.calendarMonth === 0) { this.calendarMonth = 11; this.calendarYear--; }
      else this.calendarMonth--;
      this.selectedDays = [];
    },
    nextMonth() {
      if (this.calendarMonth === 11) { this.calendarMonth = 0; this.calendarYear++; }
      else this.calendarMonth++;
      this.selectedDays = [];
    },
    onDayMousedown(day) {
      this.isDragging = true;
      this.dragStartDay = day;
      this.dragEndDay = day;
    },
    onDayMouseover(day) {
      if (this.isDragging) this.dragEndDay = day;
    },
    onDayMouseup(day) {
      if (!this.isDragging) return;
      const s = Math.min(this.dragStartDay, day);
      const e = Math.max(this.dragStartDay, day);
      if (s === e) {
        const key = this.dayKey(day);
        const idx = this.selectedDays.indexOf(key);
        if (idx >= 0) this.selectedDays.splice(idx, 1);
        else this.selectedDays.push(key);
      } else {
        for (let d = s; d <= e; d++) {
          const key = this.dayKey(d);
          if (!this.selectedDays.includes(key)) this.selectedDays.push(key);
        }
      }
      this.isDragging = false;
      this.dragStartDay = null;
      this.dragEndDay = null;
    },
    onCalMouseLeave() {
      if (this.isDragging) {
        this.isDragging = false;
        this.dragStartDay = null;
        this.dragEndDay = null;
      }
    },
    selectAllMonth() {
      this.selectedDays = [];
      for (let d = 1; d <= this.daysInMonth; d++) this.selectedDays.push(this.dayKey(d));
    },
    clearDays() {
      this.selectedDays = [];
    },

    // ── Conceptos ─────────────────────────────
    openConceptosModal() { this.$refs.xconceptosmodal.openmodal(null); },
    onConceptosSel(items) {
      this.conceptossels = items.map((x, i) => ({
        nro: i + 1, id: x.id, nombre: x.nombre, porcentual: false, descuento: 0,
      }));
    },
    onChangeTipo(item) {
      if (item.porcentual && item.descuento > 100) item.descuento = 100;
    },
    eliminarConcepto(item) {
      this.conceptossels = this.conceptossels.filter(x => x.id !== item.id);
    },

    // ── Navegación ────────────────────────────
    goNext() {
      this.errorMsg = '';
      if (this.step === 1) {
        if (this.selectedUnidades.length === 0) { this.errorMsg = 'Selecciona al menos una unidad de negocio.'; return; }
        if (!this.form.area)      { this.errorMsg = 'Selecciona un área.'; return; }
        if (!this.form.categoria) { this.errorMsg = 'Selecciona una categoría.'; return; }
      }
      if (this.step === 2) {
        if (!this.form.tipoPago) { this.errorMsg = 'Selecciona el tipo de pago.'; return; }
        if (!this.form.planPago) { this.errorMsg = 'Selecciona el plan de pago.'; return; }
      }
      if (this.step === 3) {
        if (!this.form.nombre)   { this.errorMsg = 'Ingresa el nombre de la promoción.'; return; }
        if (!this.form.estado)   { this.errorMsg = 'Selecciona el estado.'; return; }
        if (!this.form.modalidad){ this.errorMsg = 'Selecciona la modalidad.'; return; }
        if (this.conceptossels.length === 0) { this.errorMsg = 'Agrega al menos un concepto de descuento.'; return; }
        const invalido = this.conceptossels.find(x => !x.descuento || x.descuento <= 0);
        if (invalido) { this.errorMsg = `El descuento de "${invalido.nombre}" no es válido.`; return; }
      }
      this.step++;
    },

    // ── Guardar ───────────────────────────────
    async guardar() {
      this.errorMsg = '';
      if (this.selectedDays.length === 0) { this.errorMsg = 'Selecciona al menos un día de vigencia.'; return; }

      this.loading = true;
      const us = this.$store.state.DATA_USER;
      if (!us.seg_apellido) us.seg_apellido = '';
      const usuario = `${us.nombres} ${us.pri_apellido} ${us.seg_apellido}`.trim();

      const sorted = this.sortedSelectedDays;
      const unidadesSeleccionadas = this.unidades.filter(u => this.selectedUnidades.includes(u.id));
      const aplis = unidadesSeleccionadas.map(x => ({ nombre: x.nombre, codigo_id: x.id }));

      const payload = {
        nombre: this.form.nombre,
        descripcion: this.form.descripcion,
        fecha_inicio: sorted[0],
        fecha_fin: sorted[sorted.length - 1],
        fechas: [{ fecha_inicio: sorted[0], fecha_fin: sorted[sorted.length - 1] }],
        dias_vigencia: sorted,
        creado_por: usuario,
        ambiente: JSON.stringify({ ambiente: 'unidad_negocio', detalle: aplis }),
        estado: this.form.estado,
        modalidad: this.form.modalidad,
        categoria: this.form.categoria,
        tipo_pago: this.form.tipoPago,
        plan_pago: this.form.planPago,
        detalle_promocion: this.conceptossels.map(x => ({
          concepto_pago_id: x.id,
          is_porcentaje: x.porcentual,
          valor_descuento: x.descuento,
        })),
      };

      try {
        const response = await xaxios.request({
          method: 'post',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones/masivo`,
          data: payload,
        });
        this.$emit('onnew', response.data.data);
        this.dialog = false;
      } catch (e) {
        this.errorMsg = 'Error al guardar. Verifica los datos e intenta nuevamente.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Sección contenedora */
.section-box {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
.section-num-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.section-num {
  background: #1565C0;
  color: white;
  font-size: 13px;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 4px;
}
.section-title {
  font-size: 17px;
  font-weight: 600;
  color: #212121;
}
.field-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #616161;
  margin: 0;
}

/* Tarjetas de selección */
.sel-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 8px;
}
.sel-card {
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 14px 8px 12px;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.15s, background 0.15s;
  background: white;
}
.sel-card:hover    { border-color: #1976D2; background: #f5f9ff; }
.sel-card--active  { border-color: #1565C0; background: #e3f2fd; }
.sel-icon { font-size: 26px; margin-bottom: 4px; }

/* Calendario */
.cal-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.cal-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  user-select: none;
  margin-bottom: 4px;
}
.cal-header {
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  color: #9e9e9e;
  padding: 4px 0;
}
.cal-day {
  text-align: center;
  padding: 8px 4px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.1s, border-color 0.1s;
}
.cal-day:hover:not(.cal-day--empty) {
  background: #e3f2fd;
  border-color: #90CAF9;
}
.cal-day--empty { cursor: default; }
.cal-day--selected {
  background: #1565C0;
  color: white;
  font-weight: 600;
  border-color: #1565C0;
}
.cal-day--drag {
  background: #BBDEFB;
  border-color: #64B5F6;
}

/* Contador */
.cal-count {
  display: flex;
  align-items: center;
  background: #f5f5f5;
  border-radius: 6px;
  padding: 8px 14px;
}
.cal-count-num {
  font-size: 18px;
  font-weight: 700;
  color: #1565C0;
}

/* Leyenda */
.cal-legend {
  width: 14px;
  height: 14px;
  border-radius: 3px;
}
.cal-legend--selected { background: #1565C0; }
.cal-legend--drag     { background: #BBDEFB; border: 1px solid #64B5F6; }

/* Descuento input */
.end-input >>> input { text-align: end; }

/* ── Resumen ─────────────────────────────── */
.rsm-header {
  display: flex;
  align-items: center;
  background: #1565C0;
  color: white;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 8px 8px 0 0;
}
.rsm-nombre {
  background: #E3F2FD;
  padding: 12px 16px;
  border-left: 1px solid #BBDEFB;
  border-right: 1px solid #BBDEFB;
}
.rsm-nombre-text {
  font-size: 16px;
  font-weight: 700;
  color: #1565C0;
}
.rsm-nombre-desc {
  font-size: 12px;
  color: #607D8B;
  margin-top: 2px;
}
.rsm-block {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
  height: 100%;
}
.rsm-block-title {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #1565C0;
  background: #f5f9ff;
  padding: 6px 12px;
  border-bottom: 1px solid #e3f2fd;
  text-transform: uppercase;
}
.rsm-row {
  display: flex;
  align-items: flex-start;
  padding: 5px 12px;
  border-bottom: 1px solid #f5f5f5;
}
.rsm-row:last-child { border-bottom: none; }
.rsm-key {
  font-size: 11px;
  color: #9e9e9e;
  min-width: 110px;
  flex-shrink: 0;
}
.rsm-val {
  font-size: 12px;
  color: #212121;
  font-weight: 500;
}
.rsm-descuento {
  color: #2e7d32;
  font-weight: 700;
}
.rsm-empty {
  font-size: 12px;
  color: #bdbdbd;
  padding: 8px 12px;
  font-style: italic;
}
</style>
